<template>
  <v-row class="mr-4 ml-4">
    <v-autocomplete
      :label="$t(title) + '*'"
      v-model="selectedData"
      :disabled="disabled"
      :item-text="itemText"
      :item-value="itemValue"
      :key="keyName"
      :items="items"
      :error-messages="errorMessage"
      v-on:change="onChange"
      v-on:click="
        () => {
          this.wasBlurred = true;
        }
      "
      required
    />
  </v-row>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'valueEv',
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    needCheck: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    itemText: {
      type: String,
      default: '',
    },
    itemValue: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: null,
    },
    keyName: {
      type: String,
      default: '',
    },
    busyValues: [],
  },
  data() {
    return {
      selectedData: null,
      wasBlurred: false,
    };
  },
  watch: {
    value() {
      this.selectedData = this.value;
    },
  },
  computed: {
    errorMessage() {
      if (!this.needCheck && !this.wasBlurred) return '';

      return this.checkField();
    },
  },

  methods: {
    onChange() {
      this.$emit('valueEv', this.selectedData);
      this.$emit('change');
    },
    checkField() {
      if (this.value == null) return this.$t('validations.notEmpty');

      return '';
    },
  },
  mounted() {
    this.selectedData = this.value;
    if (this.selectedData === null && this.items.length === 1) {
      this.selectedData = this.items[0];
      this.onChange();
    }
  },
};
</script>
